// import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// import axios from 'axios';

// interface AuthContextType {
// 	Authorization: string;
// }

// const AuthContext = createContext<AuthContextType | undefined>(undefined);

// interface AuthProviderProps {
// 	children: ReactNode;
// }

// export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
// 	const [authHeaders, setAuthHeaders] = useState<AuthContextType>(() => {
// 		const userId = localStorage.getItem('userId');
// 		return {
// 			Authorization: `Bearer ${userId}`,
// 		};
// 	});

// 	const refreshToken = async (): Promise<{ token: string; refreshToken: string }> => {
// 		const storedRefreshToken = localStorage.getItem('refreshToken');

// 		try {
// 			const response = await axios.post(
// 				`${process.env.REACT_APP_API_URL}/user/refreshToken`,
// 				{
// 					refreshToken: storedRefreshToken,
// 				}
// 			);

// 			return response.data;
// 		} catch (error) {
// 			console.error('Error refreshing access token:', error);
// 			throw error;
// 		}
// 	};

// 	useEffect(() => {
// 		const refreshAccessToken = async () => {
// 			try {
// 				const newAccessToken = await refreshToken();
// 				const userId = newAccessToken.token;
// 				const newRefreshToken = newAccessToken.refreshToken;
// 				localStorage.setItem('userId', userId);
// 				localStorage.setItem('refreshToken', newRefreshToken);
// 				setAuthHeaders({
// 					Authorization: `Bearer ${newAccessToken.token}`,
// 				});
// 			} catch (error) {
// 				console.error('Error refreshing access token:', error);
// 			}
// 		};

// 		const checkTokenInterval = setInterval(refreshAccessToken, 3600000);

// 		return () => clearInterval(checkTokenInterval);
// 	}, []);

// 	return <AuthContext.Provider value={authHeaders}>{children}</AuthContext.Provider>;
// };

// export const useAuthHeaders = (): AuthContextType => {
// 	const context = useContext(AuthContext);
// 	if (!context) {
// 		throw new Error('useAuthHeaders must be used within an AuthProvider');
// 	}
// 	return context;
// };
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
//===============================================================================================
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import axios from 'axios';

interface AuthContextType {
	Authorization: string;
	isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
	children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
	const [authHeaders, setAuthHeaders] = useState<AuthContextType>(() => {
		const userId = localStorage.getItem('token');
		return {
			Authorization: `Bearer ${userId}`,
			isAuthenticated: !!userId,
		};
	});

	const refreshToken = async (): Promise<{ token: string; refreshToken: string }> => {
		const storedRefreshToken = localStorage.getItem('refresh');

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/user/refreshToken`,
				{
					refreshToken: storedRefreshToken,
				}
			);

			return response.data;
		} catch (error) {
			console.error('Error refreshing access token:', error);
			throw error;
		}
	};

	useEffect(() => {
		const refreshAccessToken = async () => {
			try {
				const newAccessToken = await refreshToken();
				const userId = newAccessToken.token;
				const newRefreshToken = newAccessToken.refreshToken;
				localStorage.setItem('userId', userId);
				localStorage.setItem('refreshToken', newRefreshToken);
				setAuthHeaders({
					Authorization: `Bearer ${newAccessToken.token}`,
					isAuthenticated: true,
				});
			} catch (error) {
				console.error('Error refreshing access token:', error);
			}
		};

		const checkTokenInterval = setInterval(refreshAccessToken, 3600000);

		return () => clearInterval(checkTokenInterval);
	}, []);

	return <AuthContext.Provider value={authHeaders}>{children}</AuthContext.Provider>;
};

export const useAuthHeaders = (): AuthContextType => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuthHeaders must be used within an AuthProvider');
	}
	return context;
};

export const useAuth = (): { isAuthenticated: boolean } => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return { isAuthenticated: context.isAuthenticated };
};
